import React, { useState } from "react";
import Avatar from "@mui/material/Avatar";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import AppCard from "@crema/core/AppCard";
import { Button } from "@mui/material";
import AppDialog from "@crema/core/AppDialog";
import UpcomingBirthdayForm from "./UpcomingBirthdayForm";
import { getCustomDateFormat } from "@crema/utility/Utils";

const BirthdaysItem = (props) => {
    const { icon, data } = props;
    const [userDetails, setUserDetails] = useState({});
    const [open, setOpen] = useState(false);
    const birthDayWishHandlers = (data) => {
        setOpen(true);
        setUserDetails(data);
    };
    return (
        <AppCard
            sxStyle={{
                borderRadius: (theme) =>
                    theme.components.MuiCard.styleOverrides.root.borderRadius /
                    4,
            }}
            className="card-hover"
        >
            <Box>
                <AppDialog
                    open={open}
                    onClose={() => setOpen(false)}
                    title="Send Your Best Wishes"
                >
                    <UpcomingBirthdayForm
                        setOpen={setOpen}
                        userDetails={userDetails}
                    />
                </AppDialog>
            </Box>
            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                }}
            >
                {}
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                    }}
                >
                    <Avatar
                        sx={{
                            // p: 3,
                            fontSize: { xs: 28, md: 42 },
                            height: { xs: 40, md: 45, xl: 50 },
                            width: { xs: 40, md: 45, xl: 50 },
                            // backgroundColor: bgColor,
                        }}
                    >
                        <img alt="" src={icon} />
                    </Avatar>

                    <Box
                        sx={{
                            position: "relative",
                            ml: 4,
                        }}
                    >
                        <Box
                            component="h3"
                            sx={{
                                display: "inline-block",
                                fontSize: 16,
                                mr: 3,
                                mb: 1,
                            }}
                        >
                            {data.fname}
                        </Box>
                        <Box
                            component="p"
                            sx={{
                                fontSize: 14,
                                color: "text.secondary",
                            }}
                        >
                            {getCustomDateFormat(data.dobrth)}
                        </Box>
                    </Box>
                </Box>

                <Button onClick={() => birthDayWishHandlers(data)}>Wish</Button>
            </Box>
        </AppCard>
    );
};

export default BirthdaysItem;

BirthdaysItem.defaultProps = {
    bgColor: "",
    data: {
        price: "",
        increment: null,
    },
};

BirthdaysItem.propTypes = {
    icon: PropTypes.string,
    bgColor: PropTypes.string,
    data: PropTypes.object,
    heading: PropTypes.any.isRequired,
};
